import styled from 'styled-components';

export const Price = styled.span`
  display: inline-block;
  font-size: 16px;
  line-height 22px;
  color: ${({ color }) => color};
  background-color: ${({ bgColor, noBg }) => (noBg ? 'transparent' : bgColor)};
  border-radius: 4px;
  padding: ${({ noBg }) => (noBg ? '0' : '2px 6px 0px 6px')};
  margin-bottom: ${({ marginBottom }) => marginBottom};
`;
